import React from 'react'
import { Link } from "react-router-dom";
import coreImg2 from "../assets/img/ProductsDetails/AboutConsumerEdibleOils-4.jpg";
import coreImg1 from "../assets/img/ProductsDetails/AboutConsumerEdibleOils-5.jpg";
import PageBanner from "../Components/PageBanner";
import bannerBg from '../assets/img/Banners/Productpagebanner.jpg';
const ConsumerEdibleOils = () => {
  return (
    <>
      
      <PageBanner title='Consumer Edible Oils  ' bannerBg={bannerBg} currentPage='Consumer Edible Oils  ' />
      <section className="content-block-wrapper section-padding bg-circle fix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6 pe-xl-4 col-12">
              <div className="content-block-img justify-content-center">
                <img src={coreImg1} alt="" />
              </div>
            </div>
            <div className="col-xl-6 ps-xl-5 col-lg-6 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>About Consumer Edible Oils  </h2>
                <p>
                We specialize in refining and marketing a diverse range of both indigenous and imported edible vegetable oils, catering to the food industry. Our products are designed for household consumers, offering high-quality, packaged, branded, and vitamin-fortified edible oils.  
                </p>
                <br></br>
                <p>
                Our customers span across the retail sector, food service industry, and beverage production. 
                </p>
                <br></br>
                <p>
                We proudly serve household consumers with premium brands including SHREE GITA, ULTRA LITE, and DAWN. All our packaged refined edible oils are enriched with essential vitamins A, D, and E, supporting healthy growth, cognitive development, and overall well-being.  
                </p>
              </div>
              {/* <div className="checked-features-list style-2">
                <ul>
                  <li>Brand Identity</li>
                  <li>Website Design &amp; Development</li>
                  <li>SEO &amp; Analytics</li>
                </ul>
              </div> */}
              {/* <Link to="/about" className="theme-btn style-3 mt-30">
                click here
              </Link> */}
            </div>
          </div>
          <div className="row align-items-center section-padding pb-0">
            <div className="col-xl-6 col-lg-6 col-12 mt-5 mt-lg-0 order-2 order-lg-1">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>Oil Refining Capabilities </h2>
                <p>
                We operate a state-of-the-art vegetable oil refinery located in Morbi, Gujarat. Our facilities leverage the latest refining technology and are managed by highly trained technical teams. 
                </p>
                <br></br>
                <p>
                All our processing plants adhere to international quality assurance and food safety standards, including HACCP and ISO 22000, ensuring the highest level of quality and safety in our products. 
                </p>
                
              </div>
            
              <Link to="/contact" className="theme-btn style-3 mt-30">
                Contact Us
              </Link>
            </div>
            <div className="col-xl-6 col-lg-6 ps-xl-5 col-12 order-1 order-lg-2">
              <div className="content-block-img justify-content-center">
                <img src={coreImg2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ConsumerEdibleOils
